import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ExpiredMembershipUsersTable from "./ExpiredMembershipUsersTable";
import { confirmDelete, customConfirmPopup } from "../../utils/commonFunctions";
import { getExpiredMemberships } from "../../redux/actions/expiredMembershipsAction";

const ExpiredMembershipUsers = () => {
    const history = useNavigate();
    const dispatch = useDispatch();

    let allExpiredMemberships = useSelector((state) => state.expiredMemberships.allExpiredMemberships);
    const totalRecords = allExpiredMemberships?.totalRecords || 0;

    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState("");

    useEffect(() => {
        dispatch(getExpiredMemberships(page, limit, search));
    }, [dispatch, page, limit, search]);

    const getFilteredData = (data, search) => {
        if (search.length) {
            data = data?.filter(
                (item) =>
                    item?.caller?.mobile?.toLowerCase().includes(search.toLowerCase()) ||
                    item?.caller?.email?.toLowerCase().includes(search.toLowerCase()) ||
                    item?.reciever?.mobile?.toLowerCase().includes(search.toLowerCase()) ||
                    item?.reciever?.email?.toLowerCase().includes(search.toLowerCase())
            );
        }
        return data;
    };

    allExpiredMemberships = getFilteredData(allExpiredMemberships?.data, search);
    allExpiredMemberships = allExpiredMemberships?.length > 0 && allExpiredMemberships?.map((item) => ({
        ...item,
        time: new Date(item.time),
    }));

    return <ExpiredMembershipUsersTable heading="All Expired Memberships" allExpiredMemberships={allExpiredMemberships} loading={loading} history={history} search={search} setSearch={setSearch} page={page} limit={limit} totalRecords={totalRecords} setPage={setPage} setLimit={setLimit} />;
};

export default ExpiredMembershipUsers;
